// extracted by mini-css-extract-plugin
export default {"heads":"CompanyListPage_heads__wjKZq","keywordAndSortOptions":"CompanyListPage_keywordAndSortOptions__iMvKq","keywordInputContainer":"CompanyListPage_keywordInputContainer__8BJr+"};